// Trim ranges are in unix seconds.
export const TRIM_MAX_SECONDS = 5 * 60;
export const TRIM_MIN_SECONDS = 1;

/**
 * Moves one edge of the range to `nextSec`, keeping the range between
 * TRIM_MIN_SECONDS and TRIM_MAX_SECONDS long and inside `bounds`. The other
 * edge never moves.
 */
export const clampTrimRange = (edge, nextSec, { startTime, endTime }, bounds = {}) => {
  const lower = Number.isFinite(bounds.min) ? bounds.min : -Infinity;
  const upper = Number.isFinite(bounds.max) ? bounds.max : Infinity;
  if (edge === "start") {
    let start = Math.min(nextSec, endTime - TRIM_MIN_SECONDS);
    start = Math.max(start, endTime - TRIM_MAX_SECONDS, lower);
    return { startTime: Math.round(start), endTime };
  }
  let end = Math.max(nextSec, startTime + TRIM_MIN_SECONDS);
  end = Math.min(end, startTime + TRIM_MAX_SECONDS, upper);
  return { startTime, endTime: Math.round(end) };
};

/** Default selection: TRIM_MAX_SECONDS from the playhead, kept in the past. */
export const createDefaultTrimRange = (playheadSec, nowSec) => {
  const latestEnd = Math.floor(nowSec);
  let startTime = Math.floor(playheadSec);
  let endTime = startTime + TRIM_MAX_SECONDS;
  if (endTime > latestEnd) {
    endTime = latestEnd;
    startTime = endTime - TRIM_MAX_SECONDS;
  }
  return { startTime, endTime };
};

export const isValidTrimRange = ({ startTime, endTime }, nowSec) => {
  const length = endTime - startTime;
  return Number.isFinite(length)
    && length >= TRIM_MIN_SECONDS
    && length <= TRIM_MAX_SECONDS
    && endTime <= Math.ceil(nowSec);
};

/** True when any recording (seconds) overlaps the range. */
export const trimRangeHasRecording = ({ startTime, endTime }, records = []) =>
  records.some((record) => Number(record.startTime) < endTime && Number(record.endTime) > startTime);

export const formatTrimDuration = (seconds) => {
  const total = Math.max(0, Math.round(seconds));
  return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
};
